<template>
	<div class="ExaminationResult sw-container">
		<div class="common-nav">
			<span class="s1">您的位置</span>
			<span class="s2">|</span>
			<span class="s1">考试</span>
			<span class="s2">|</span>
			<span class="s3">考试结果 </span>
		</div>
		<div class="ExaminationResult-main" v-if="dataInfo.passed == '不合格'">
			<img class="ExaminationResult-img" src="../../assets/img/kao3.png" />
			<div class="ExaminationResult-main-r">
				
				<!-- <Circle :size="200" :trail-width="4" :stroke-width="5" :percent="75" stroke-linecap="square"
					stroke-color="#EC6941"> -->
					<p class="p1">{{ dataInfo.score }}</p>
					<p class="p2">考试结果</p>
				<!-- </Circle> -->
				<div class="ExaminationResult-msg">
					<img src="../../assets/img/kicn3.png" /> 很遗憾，望再接再厉
				</div>
				<Circle :percent="80">
					<span  style="font-size:24px">80%</span>
				</Circle>
				<div class="ExaminationResult-btn" @click="goExamination">
					继续考试
					<!-- 剩余{{ dataInfo.examnum }}次 -->
				</div>
			</div>
		</div>
		<div class="ExaminationResult-main" v-if="dataInfo.passed == '合格'">

			<img class="ExaminationResult-img2" src="../../assets/img/kao4.png" />
			<div class="ExaminationResult-main-r ExaminationResult-main-r2">
				<div style="padding-left: 70px;">
					<!-- <Circle :size="200" :trail-width="4" :stroke-width="5" :percent="75" stroke-linecap="square"
						stroke-color="#31AF58"> -->
						<p class="p3">{{ dataInfo.score }}</p>
						<p class="p2">考试结果</p>
					<!-- </Circle> -->
					<div class="ExaminationResult-msg ExaminationResult-msg2">
						<img src="../../assets/img/kicn4.png" /> 恭喜，通过考试！
					</div>
				</div>
				<div class="ExaminationResult-btn2" @click="goBook">查看凭证</div>
				<div class="ExaminationResult-btn" @click="goExamination">
					继续考试
					<!-- 剩余{{ dataInfo.examnum }}次 -->
				</div>
			</div>
		</div>
    <Modal v-model="isShow" :closable="false" footer-hide width="594"
           class-name="vertical-center-modal invoiceModal">
      <h4 class="city-title">考试通过确认</h4>
<!--      <p class="tishi" style="padding: 10px">市、县(区)选择、会计人员信息采集是否完成，请登录 <a href="https://czt.yn.gov.cn/rygl/w/collection/acms?login_type=eduSignUp%22" style="color: red">云南省会计人员管理系统(点击直达)</a>查看。</p>-->
<!--      <p class="tishi"  style="padding: 10px">核查方式：云南省会计人员管理系统&#45;&#45;个人信息汇总&#45;&#45;查看“采集状态”，是否是5个绿色字体“已完成采集”。如果是即可。如果不是，请自行核实会计人员信息采集是否完成，若未完成，请务必在考试合格前采集成功。</p>-->
      <p class="tishi2">{{msg}}</p>

      <div class="btn-list">
        <div class="head-login-btn" style="margin-top: 30px;" @click = "isShow= false">确认</div>
      </div>
    </Modal>


    <Modal v-model="isShowModal" :closable="false" footer-hide width="594" :mask-closable="false"
           class-name="vertical-center-modal invoiceModal">
      <template>
        <Steps :current="whichStep">
          <Step title="信息确认">
          </Step>
          <Step title="截图上传" content="请上传会计人员信息采集页面截图"></Step>
          <Step title="地区采集" content="会计人员信息采集市、县级行政区划"></Step>

          <Step title="完成"></Step>
        </Steps>
      </template>
      <div v-if="whichStep == 0">
        <h4 class="city-title">信息采集确认</h4>
        <p class="tishi" style="padding: 10px">会计人员信息采集是否完成，请登录 <a
            href="https://czt.yn.gov.cn/rygl/w/collection/acms?login_type=eduSignUp%22" style="color: red">云南省会计人员管理系统(点击直达)</a>查看。
        </p>
        <p class="tishi" style="padding: 10px">
          核查方式：云南省会计人员管理系统--个人信息汇总--查看“采集状态”，是否是5个绿色字体“已完成采集”。如果是即可。如果不是，请自行核实会计人员信息采集是否完成，若未完成，请务必在考试前采集成功。</p>
        <div class="btn-list">
          <div class="head-login-btn quxiao" style="margin-top: 30px;" @click="closePopup">未采集成功</div>
          <div class="head-login-btn" style="margin-top: 30px;" @click="nextStep">已采集成功</div>
        </div>
      </div>

      <div v-if="whichStep == 2">
        <h4 class="city-title">会计人员信息采集市、县级行政区划</h4>
        <p class="tishi" style="padding: 10px">市、县(区)选择、会计人员信息采集是否完成，请登录 <a
            href="https://czt.yn.gov.cn/rygl/w/collection/acms?login_type=eduSignUp%22" style="color: red">云南省会计人员管理系统(点击直达)</a>查看。
        </p>
        <p class="tishi" style="padding: 10px">
          注意：若您选择的的会计人员信息采集市、县级行政区划与您在云南省会计人员管理系统采集信息不一致，将导致您本年度继续教育记录及学分无法上传，请核实后再进行录入。</p>
        <!--        <p class="tishi2">选择错误的市、信息采集未完成，将影响学习记录上传。</p>-->
        <Form class="head-login" ref="formValidate2" :model="formValidate2" :label-width="120">
          <FormItem label="市" prop="city">
            <Select v-model="formValidate2.city" placeholder="市" @on-change="handleChangeTypeCity">
              <Option v-for='(item,index) in cityList' :value="item.cityid">{{ item.city }}</Option>
            </Select>
          </FormItem>
          <FormItem label="区" prop="area">
            <Select v-model="formValidate2.area" placeholder="区/县" @on-change="handleChangeTypeQu">
              <Option v-for='(item,index) in areaList' :value="item.areaid">{{ item.area }}</Option>
            </Select>
          </FormItem>
        </Form>
        <div class="btn-list">
          <div class="head-login-btn quxiao" style="margin-top: 30px;" @click="previousStep">上一步</div>
          <div class="head-login-btn" style="margin-top: 30px;" @click="nextStep">下一步</div>
        </div>
      </div>

      <div v-if="whichStep == 1">
        <h4 class="city-title">截图上传</h4>
        <p class="tishi" style="padding: 10px">请登录 <a
            href="https://czt.yn.gov.cn/rygl/w/collection/acms?login_type=eduSignUp%22" style="color: red">云南省会计人员管理系统(点击直达)</a>截图。
        </p>
        <p class="tishi" style="padding: 10px">请上传会计人员信息采集页面截图（截图每个信息要求清晰完整无遮挡），截图如下：
          <Col flex="1">
            <img src="https://img.aierxin.cn/jietu/jietu.png" @click="open()" style="width: 80% ;height: 350px"/>
          </col>
        </p>

        <div class="info">
          <div class="top">
            <div class="upload display-flex align-items-center">
              <div class="lf">
                <img v-if="formValidate2.img != '' " :src="formValidate2.img" style="width:250px ;height: 150px" alt/>
                <img v-else src="../../assets/img/header.jpg" alt/>
              </div>
              <div class="rg">
                <div class="imgUpload">

                  <label type="success" long class="uploadImg" for="uploadImg">上传</label>
                  <input
                      @change="uploadHeader"
                      type="file"
                      id="uploadImg"
                      style="display: none;"
                      accept="image/png, image/jpeg, image/jpg, image/gif"
                  />
                  <!-- <Upload
                    ref="upload"
                    :on-success="handleSuccess"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="2048"
                    type="drag"
                    action="http://121.37.247.227:1272/file/uploadToPath"
                  >
                    <span>重新上传</span>
                  </Upload>-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="btn-list">
          <div class="head-login-btn quxiao" style="margin-top: 30px;" @click="previousStep">上一步</div>
          <div class="head-login-btn" style="margin-top: 30px;" @click="nextStep">下一步</div>
        </div>
      </div>


      <div v-if="whichStep == 3">

        <Icon type="md-checkmark-circle-outline" :color="color" style="width: 100% " :size="100"/>
        <div class="btn-list">
          <div class="head-login-btn" style="margin-top: 30px;" @click="nextStep">关闭</div>
        </div>
      </div>
    </Modal>
	</div>
</template>

<script>
import {
  postData, postDataNew, postUploadNew,
  showLoading
} from "../../assets/api/api.js";
	export default {
		name: "ExaminationResult",
		components: {},
		data() {
			return {
        isShowModal: false,
        formValidate2: {
          city: '',
          area: '',
          img: '',
        },
        cityList: [],
        areaList: [],
        province: '530000',
        addressCity: '',
        addressArea: '',
        address: '',
        courseId: '',
        treepath: '',
        course: '',
        special: null,
        img: '',
        whichStep: 0,
        isShow:false,
				search: "",
				dataInfo: "",
        msg:'',
        comboId:"",
			};
		},
		created() {
      // this.checkTree()

			this.dataInfo = JSON.parse(sessionStorage.getItem("ExaminationResult"));
      this.comboId = this.dataInfo.comboId
      console.log(this.comboId)
      if (this.dataInfo.passed == "合格"){
        postDataNew("/jxjyapi/tenpoint/regionMsg", {'comboUserId':this.dataInfo.comboId}).then((res) => {
          if (res.code == true) {
            this.msg = res.data.msg
            this.isShow = true
          }
        })
      }




			console.log(this.isShow);
		},

		computed: {},
		methods: {
			goExamination() {
				this.$router.push({
					path: "/Examination",
				});
			},
      closePopup() {
        this.isShowModal = false
        this.whichStep == 1;
      },
      getCity() {
        postDataNew("/jxjyapi/login/cityList").then((res) => {
          this.cityList = res.data.list.filter(item => item.is_show == 1);
        }).catch(function (error) {

        });
      },

      checkTree(){


        var params = {
          comboUserId: this.comboId
        };
        console.log(this.comboId,"dataInfo")
        postDataNew("/jxjyapi/tenpoint/checkTreePath", params).then(res => {
          if (res.code == false) {
            // this.isShowModal = true;
            this.getCity();

            postDataNew("/jxjyapi/tenpoint/getOldOrder", {uid: this.$store.state.master.user.id}).then(res => {

              if (res.code == true) {
                this.formValidate2.address = res.data.comboUser.address;
                this.formValidate2.img = res.data.comboUser.img_path;
                // treepath逗号分隔
                var treepath = res.data.comboUser.treepath.split(",");
                this.treepath = res.data.comboUser.treepath;
                    this.address = res.data.comboUser.address;
                this.formValidate2.city = treepath[1];
                this.getAreaList();
                this.formValidate2.area = treepath[2];
                this.formValidate2.qu = treepath[2];
              }

            })
          }
        })
      },



      getAreaList() {
        var params = {
          city: this.formValidate2.city,
        }
        postDataNew("/jxjyapi/login/getAreasList  ", params).then((res) => {
          this.areaList = res.data.list;
        });
      },
      open() {
        const image = new Image()
        image.src = "https://img.aierxin.cn/jietu/jietu.png"
        image.onload = () => {
          //创建弹出层
          const previewContatiner = document.createElement('div')
          previewContatiner.style.position = 'fixed'
          previewContatiner.style.top = 0
          previewContatiner.style.bottom = 0
          previewContatiner.style.left = 0
          previewContatiner.style.right = 0
          previewContatiner.style.zIndex = 9999
          previewContatiner.style.backgroundColor = 'rgba(0,0,0,0.8)'
          previewContatiner.style.display = 'flex'
          previewContatiner.style.justifyContent = 'center'
          previewContatiner.style.alignItems = 'center'
          document.body.appendChild(previewContatiner)
          //在弹出层增加图片
          const previewImage = document.createElement('img')
          previewImage.src = "https://img.aierxin.cn/jietu/jietu.png"
          previewImage.style.maxWidth = '80%'
          previewImage.style.maxHeight = '80%'
          previewImage.style.zIndex = 9999
          previewContatiner.appendChild(previewImage)
          //点击弹出层，关闭预览
          previewContatiner.addEventListener('click', () => {
            document.body.removeChild(previewContatiner)
          })
        }
        image.onerror = function () {
          console.log('图片加载失败')
        }
      },
      //上传头像
      uploadHeader(event) {
        const formData = new FormData();
        var file = event.target.files[0];
        console.log(event)
        if (file) {
          formData.append("file", file);

          // var params ={
          //   file: file
          // }
          // console.log(params)
          // postDataNew("/jxjyapi/tenpoint/image", params).then(res => {
          //   if (res.code == false) {
          //     this.$Message.error("头像上传失败");
          //   } else {
          //     this.img = res.data.path;
          //     this.$Message.success("头像上传成功");
          //   }
          // })
          postUploadNew("/jxjyapi/tenpoint/image", formData).then((res) => {
            console.log(res, 99999999999)
            if (res.code == false) {
              this.$Message.error("上传失败");
            } else {
              this.formValidate2.img = res.data.path;
              this.$Message.success("上传成功");
            }
            // this.$Message.success("头像上传成功");
            // this.img = res.data;
          });
        }
      },
      handleChangeTypeQu(val) {
        if (this.formValidate2.city != '') {
          this.formValidate2.qu = val;
          let index = this.areaList.findIndex(function (res) {
            return res.areaid === val
          });
          this.addressArea = this.areaList[index].area;
          this.address = '云南省' + this.addressCity + this.addressArea;
          this.treepath = this.province + "," + this.formValidate2.city + "," + this.formValidate2.qu;
        } else {
          this.$Message.error("请先选择所在城市");
          return
        }

      },
      handleChangeTypeCity(val) {
        this.formValidate2.city = val;
        let index = this.cityList.findIndex(function (res) {
          return res.cityid === val
        });
        this.addressCity = this.cityList[index].city;
        this.getAreaList();
      },
      previousStep() {
        this.whichStep--
      },
      submitAddress() {
        if (!this.formValidate2.city) {
          this.$Message.error("请先选择所在城市");
          return
        }
        if (!this.formValidate2.qu) {
          this.$Message.error("请先选择所在地区");
          return
        }
        if (!this.formValidate2.img) {
          this.$Message.error("请先上传截图");
          return
        }
        var params = {
          comboUserId: this.comboId,
          treepath: this.treepath,
          address: this.address,
          img: this.formValidate2.img
        }
        postDataNew("/jxjyapi/tenpoint/bindArea", params).then((res) => {
          if (res.code == true) {
            this.whichStep = 3;
          } else {
            this.$Message.error("所在地址上传失败");
            return
          }
        }).catch(function (error) {
          // console.log(error)
        });
      },
      nextStep() {
        if (this.whichStep == 0) {
          this.whichStep++
          return
        }
        if (this.whichStep == 1) {
          if (!this.formValidate2.img) {
            this.$Message.error("请先上传截图");
            return
          }

          this.whichStep++
          return
        }
        if (this.whichStep == 2) {
          if (!this.formValidate2.city) {
            this.$Message.error("请先选择所在城市");
            return
          }
          if (!this.formValidate2.qu) {
            this.$Message.error("请先选择所在地区");
            return
          }
          // this.whichStep++
          // return
        }
        if (this.whichStep + 1 == 3) {
          this.submitAddress();
        }
        if (this.whichStep == 3) {
          this.isShowModal = false;
          this.$router.push({
            path: "/ExaminationInfo",
            query: {
              cid: this.course.cid,
              orderId: this.course.oid,
              id: this.course.id
            }
          });
        }

      },
			goBook() {
				this.$router.push({
					path: "/attendanceProcess/proof",
					query: {
						id: this.$route.query.id,
					},
				});
			},
		},
		watch: {},
	};
</script>

<style lang="scss">
	.ExaminationResult {
		padding-bottom: 30px;

		&-main {
			background: #fff;
			height: 500px;
			display: flex;
			padding: 70px 0;

			&-r {
				flex: 1;
				// padding-left: 188px;
				border-left: 1px solid #eeeeee;
				text-align:center;
			}

			&-r2 {
				padding-left: 118px;
			}

			.p1 {
				color: #ec6941;
				font-size: 72px;
				text-align: center;
			}


			.p2 {
				color: #666666;
				font-size: 14px;
				text-align: center;
			}

			.p3 {
				color: #31af58;
				font-size: 72px;
				text-align: center;
			}
		}

		&-img {
			margin-left: 160px;
			margin-right: 160px;
		}

		&-img2 {
			margin-left: 106px;
			margin-right: 96px;
		}

		&-msg {
			display: flex;
			align-items: center;
			justify-content:center;
			font-size: 20px;
			color: #ec6941;
			margin-top: 32px;
			margin-bottom: 58px;

			img {
				margin-right: 12px;
				margin-left: 0;
			}
		}

		&-msg2 {
			color: #31af58;
		}

		&-btn {
			width: 160px;
			height: 40px;
			background: rgba(34, 34, 34, 1);
			border-radius: 4px;
			cursor: pointer;
			text-align: center;
			line-height: 40px;
			color: #fff;
			font-size: 14px;
			margin-left: 25px;
			display: inline-block;
		}

		&-btn:hover {
			background: rgba(34, 34, 34, 0.8);
		}

		&-btn2 {
			width: 160px;
			height: 40px;
			background: rgba(55, 188, 95, 1);
			border-radius: 4px;
			cursor: pointer;
			text-align: center;
			line-height: 40px;
			color: #fff;
			font-size: 14px;
			display: inline-block;
		}

		&-btn2:hover {
			background: rgba(55, 188, 95, 0.8);
		}
	}

  .city-title {
    font-size: 20px;
    color: #303133;
    padding: 20px 0;
    text-align: center;
  }

  .btn-list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }

  .head-login-btn {
    width: 160px;
    border-radius: 4px;
    margin-bottom: 20px;
  }

  .quxiao {
    background-color: #f1f1f1 !important;
    color: #303133 !important;
  }

  .tishi {
    font-size: 14px;
    color: #ec6941;
    margin: 0 30px;
    margin-left: 36px;
    margin-top: 10px;
  }
  .tishi2 {
    font-size: 19px;
    color: #ff0000;
    margin: 0 30px;
    margin-left: 36px;
    margin-top: 10px;
  }
  //.tishi设置背景
  .tishi{
    border: 1px solid #FFD797;
    width: 100%;
    margin-left: -3px;
    line-height: 30px;
    background-color: #FFF7E6;
    margin-bottom: 10px;
  }


  .tishi a{
    color: #faf9f9;
  }
  .tishi1{
    width: 100%;
    height: 100%;
    display: flex;
    font-size: 16px;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  //设置.tishi1 p的样式
  .tishi1 p{
    font-size: 16px;
    color: #000000;
    text-indent: 20px;
    padding: 5px;
    margin-bottom: 20px;
  }
  .titels{
    color: #000000;
    width: 100%;
    font-weight: bold;
    margin-top: 20px;
    margin-left: 20px;
    height: 30px;
    display: flex;
  }
  .titels p{
    font-size: 26px;
    color: #000000;
    margin-left: 10px;
  }
  .tt{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .titels img{
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .titelimg{
    width: 20px;
    height: 20px;
    margin-top: 20px;
    margin-right: 20px;
  }
  .uploadImg {
    display: inline-block;
    text-align: center;
    cursor: pointer;
    width: 90px;
    height: 30px;
    background: rgba(49, 175, 88, 1);
    border-radius: 4px;
    display: inline-block;
    line-height: 30px;
    color: #fff;
    border: none;
  }

</style>